import { Link } from "react-router-dom";

/**
 * Slim bottom anchor for the mobile app shell.
 *
 * Two jobs:
 *   1. Give the last card on a page (e.g. PracticeTestCard at the bottom
 *      of Home) breathing room from the viewport edge. Without a footer,
 *      the card touches the safe-area / nav-bar and looks cut off.
 *   2. Provide Privacy / Terms / Support links so the legal surface is
 *      always one tap away from inside the app, matching the marketing
 *      footer convention.
 *
 * Desktop renders DesktopShell which has its own bottom-of-sidebar
 * affordances; this component is mobile-only and is rendered by
 * AppShell when viewport === "mobile".
 */
export function MobileFooter() {
  return (
    <footer
      style={{
        marginTop: "var(--sp-6)",
        padding: "20px 16px",
        paddingBottom: "max(20px, env(safe-area-inset-bottom))",
        borderTop: "1px solid var(--border-line)",
        background: "var(--bg-1)",
      }}
    >
      <ul
        style={{
          listStyle: "none",
          margin: 0,
          padding: 0,
          display: "flex",
          gap: 18,
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        <li><FooterLink to="/privacy">Privacy</FooterLink></li>
        <li><FooterLink to="/terms">Terms</FooterLink></li>
        <li><FooterLink to="/support">Support</FooterLink></li>
      </ul>
      <p
        style={{
          textAlign: "center",
          color: "var(--fg-3)",
          fontFamily: "var(--font-mono)",
          fontSize: 10,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          marginTop: 12,
          margin: "12px 0 0",
        }}
      >
        &copy; {new Date().getFullYear()} Break the Test
      </p>
    </footer>
  );
}

function FooterLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <Link
      to={to}
      className="bht-tap-44-inline"
      style={{
        color: "var(--fg-2)",
        fontFamily: "var(--font-mono)",
        fontSize: 11,
        fontWeight: 500,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        textDecoration: "none",
      }}
    >
      {children}
    </Link>
  );
}
